import { axios } from '@/plugins/axios';

export const getFunds = (params) => axios.get('/funds', {params: params})
  .then(res => res.data);